import {
    Switch,
    Route,
} from "react-router-dom";
import { Landing, Portfolio } from "../screens";

const Main = () => {
    return (
        <Switch>
          <Route exact path="/">
            <Landing />
          </Route>
          <Route path="/portfolio">
            <Portfolio />
          </Route>
        </Switch>
    )
}

export default Main